import { ApiUrls } from '@/common/domain/Endpoints.domain';
import { contentInstance } from '@/common/service/api/Axios';
import { ICommonPageParams } from '@/screens/CommonPage/domain/CommonPage.domain';
import { TPublicBlogs } from '../domain/Blogs.domain';

export const fetchBlogs = async (params: ICommonPageParams): Promise<TPublicBlogs> => {
    try {
        const { data } = await contentInstance.get<TPublicBlogs>(ApiUrls.public.blog, {
            params: {
                ...(params.category_id && { category_id: params.category_id }),
                ...(params.limit && { limit: params.limit }),
                ...(params.pager && { pager: params.pager }),
                ...(params.landmark_id && { landmark_id: params.landmark_id }),
                ...(params.author && { author: params.author }),
                ...(params.state && { state: params.state }),
                ...(params.withRating && { withRating: params.withRating }),
            },
        });

        return data;
    } catch (err) {
        console.log(`Failed fetchBlogs: public/blog ${err}`);
        return { items: [], pager: '' };
    }
};
